import '.a{display:flex;}.ssr-plugin'
import '.hb{background-color:white;}.ssr-plugin'
import '.hc{border-radius:20px;}.ssr-plugin'
import '.ao{border:var(--border-subtle);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.bv{padding:1rem;}.ssr-plugin'
import '.q{width:100%;}.ssr-plugin'
import '.by{align-items:flex-start;}.ssr-plugin'
import '.bq{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.hd{width:6.1875rem;}.ssr-plugin'
import '.he{border-radius:9px;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { LinkAnchor } from '@app/components/core/link/LinkAnchor'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  intro?: string
  time: string
  location: string
  onClick?: () => void
  to?: string
  style?: Style
}

export const Event = ({
  date,
  month,
  category,
  title,
  intro,
  time,
  location,
  onClick,
  to,
  style,
}: EventProps) => {
  const content = (
    <styled.div className="a hb hc ao ai bv q by"
      onClick={onClick}
      style={{
        cursor: onClick || to ? 'pointer' : 'default',
        ...style,
      }}
    >
      {/* Date Section */}
      <div className="bq bv a e f b hd he"
        data-testid="event-date-section"
      >
        <Text.Large
          style={{
            fontSize: '3.6rem',
            fontWeight: '700',
            color: 'var(--palette-blue-500)',
            lineHeight: '1',
            margin: 0,
          }}
          color="var(--palette-blue-500)"
        >
          {date}
        </Text.Large>
        <Text.ExtraSmall color="var(--palette-blue-500)">
          {String(month).toUpperCase()}
        </Text.ExtraSmall>
      </div>

      {/* Event Details Section */}
      <Column
        style={{
          height: '100%',
          padding: '0 1rem',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
        gap="0.5rem"
      >
        <div className="an">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--brand-primary)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--brand-secondary)"
          >
            {title}
          </Text.Medium>

          {/* Intro */}
          {intro && (
            <Text.Small
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
              color="var(--palette-blue-600)"
            >
              {intro}
            </Text.Small>
          )}
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--brand-secondary)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </styled.div>
  )

  if (to) {
    return <LinkAnchor to={to}>{content}</LinkAnchor>
  }

  return content
}
